import React from "react";
import {TIME_UNITS} from "components/basic/dropdowns/time-unit-dropdown/timeUnits";
import {Dropdown} from "primereact/dropdown";

interface ITimeUnitDropdownProps {
    id?: string;
    className?: string;
    value: string;
    onChange: (e) => void;
}

const TimeUnitDropdown = ({value, onChange, className, id}: ITimeUnitDropdownProps) => {
    return (
        <Dropdown
            id={id}
            className={className}
            value={value}
            onChange={e => onChange(e)}
            options={TIME_UNITS}/>
    )
}

export default TimeUnitDropdown;